module.exports = __webpack_public_path__ + "images/e0b58e08dd8f843a7f9f660de57a2b54-logo.png";